import { Component, OnInit, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { EngagementType } from '@interfaces';
import { CommonScheduledFollowUpsGridPart } from '../../../../../../../ui/widget';
import { AccCohortPageService, } from '../../../acc-cohort.page.service';


@Component({
	selector: 'acc-scheduled-follow-ups-view-part',
	standalone: true,
	imports: [CommonScheduledFollowUpsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-scheduled-follow-ups-view.part.html',
})
export class AccScheduledFollowUpsViewPart implements OnInit {

	public readonly pageService = inject(AccCohortPageService);
	public followUps = computed(() => (this.pageService.followUps() || []));

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.scheduledFollowUps);
	}

}